export const ToastType = {
	SUCCESS: "success",
	INFO: "info",
	WARNING: "warning",
	ERROR: "error"
}